import { UnknownError, NetworkError, ConnectionAbortedError, TimeoutError, InvalidSdkConfigurationError, InvalidRegionOrHostError, InvalidRegionError, InvalidHostError } from "@smash-sdk/core";
import { GenericError as VerifyChallengeGenericError } from "./types/VerifyChallenge/VerifyChallengeError";
import { InvalidParameterError as VerifyChallengeInvalidParameterError } from "./types/VerifyChallenge/VerifyChallengeError";
import { UnauthorizedError as VerifyChallengeUnauthorizedError } from "./types/VerifyChallenge/VerifyChallengeError";
import { ForbiddenError as VerifyChallengeForbiddenError } from "./types/VerifyChallenge/VerifyChallengeError";
import { InternalServerError as VerifyChallengeInternalServerError } from "./types/VerifyChallenge/VerifyChallengeError";
import { BadGatewayError as VerifyChallengeBadGatewayError } from "./types/VerifyChallenge/VerifyChallengeError";
import { GatewayTimeoutError as VerifyChallengeGatewayTimeoutError } from "./types/VerifyChallenge/VerifyChallengeError";
export const errors = {
    VerifyChallenge: {
        InvalidParameterError: VerifyChallengeInvalidParameterError,
        UnauthorizedError: VerifyChallengeUnauthorizedError,
        ForbiddenError: VerifyChallengeForbiddenError,
        InternalServerError: VerifyChallengeInternalServerError,
        BadGatewayError: VerifyChallengeBadGatewayError,
        GatewayTimeoutError: VerifyChallengeGatewayTimeoutError,
        GenericError: VerifyChallengeGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    VerifyChallengeError: {
        InvalidParameterError: VerifyChallengeInvalidParameterError,
        UnauthorizedError: VerifyChallengeUnauthorizedError,
        ForbiddenError: VerifyChallengeForbiddenError,
        InternalServerError: VerifyChallengeInternalServerError,
        BadGatewayError: VerifyChallengeBadGatewayError,
        GatewayTimeoutError: VerifyChallengeGatewayTimeoutError,
        GenericError: VerifyChallengeGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InvalidSdkConfigurationError,
    InvalidRegionOrHostError,
    InvalidRegionError,
    InvalidHostError,
};
